export default class InfluenceChain {
  #points;

  constructor(game, index, text) {
    this.index = index;
    this.black = 0;
    this.white = 0;
    this.#points = [];

    for(const i of this.#splitText(text)) {
      if(i.inf !== 0) {
        Object.assign(i, game.decode(i.point));
        this.#points.push(i);

        if(i.inf > 0)
          this.black++;
        else
          this.white++;
      }
    }
  }

  *#splitText(text) {
    let point = null;
    for(const t of text.split(' ')) {
      const w = t.trim();
      if(!w) continue;

      if(point) {
        yield { point, inf: parseFloat(w) }
        point = null;
      } else {
        point = w;
      }
    }
  }

  *iterate() {
    for(const p of this.#points)
      yield p;
  }
}
